import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {useParams, useRouteMatch, Link, useHistory, Switch, Route} from 'react-router-dom'
import ExhibitonInMuseumDetail from './current_exhibition';
import ExhibitionInMuseumUpcomingDetail from './upcoming_exhibition';
import MapInMuseumDetail from './map_in_detail';

function MuseumDetail(){
    const [museum, setMuseum] = useState();
    let {id} = useParams();
    let {url} = useRouteMatch();
    let tag;

    useEffect(()=>{
        getMuseum()
        getTag()
    }, [id])

    const history = useHistory();

    function getTag(){
        let arrayUrl = url.split('/')
        tag = arrayUrl[3];
    };

    // function getMuseum(){
    //     axios.get(`/api/get_museum/${id}`)
    //     .then(museumDataFromMongo=>{
    //         setMuseum(museumDataFromMongo.data)
    //     })
    //     .catch(error=>{
    //         console.log(error)
    //     })
    // }

    function getMuseum(){
        if(id!=='map'){
            axios.get(`/api/get_museum/${id}`)
            .then(museumDataFromMongo=>{
                setMuseum(museumDataFromMongo.data)
            })
            .catch(error=>{
                console.log(error)
            })
        }
    }

    const open_tag = 
    <p>Open</p>

    const close_tag = 
    <p>Close</p>

    const contemporary_art_tag = 
    <p>Contemporary Art</p>

    const modern_art_tag = 
    <p>Modern Art</p>

    const classic_art_tag = 
    <p>Classic Art</p>

    const ancient_art_tag = 
    <p>Ancient Art</p>

    const applied_fine_arts_tag = 
    <p>Applied Fine Arts</p>

    const photograph_tag = 
    <p>Photograph</p>

    const free_admission_tag = 
    <p>Free Admission</p>

    const recommendation_tag = 
    <p>Recommendation</p>

    const open_monday_tag = 
    <p>Open Monday</p>

    return(
        
        <div className='detail'>
        
            {(museum)?<div>
            <div>
           
            <div className='tag_in_museum_detail'>
             {(museum.status =='Open')? open_tag :''}
             {(museum.status =='Close')? close_tag :''}
             {(museum.genre =='Contemporary art')?contemporary_art_tag :''}
             {(museum.genre =='Modern art')?modern_art_tag :''}
             {(museum.genre =='Classic art')?classic_art_tag :''}
             {(museum.genre =='Ancient art')?ancient_art_tag :''}
             {(museum.genre =='Applied fine arts')?applied_fine_arts_tag :''}
             {(museum.genre =='Photograph')?photograph_tag :''}
             {(museum.isOpenMonday =='Yes')?open_monday_tag :''}
             {(museum.isFreeAdmission =='Yes')?free_admission_tag :''}
             {(museum.isRecommendation =='Yes')?recommendation_tag :''}
            </div>
            <h2>{museum.name}</h2>
            </div>

            <div className='detail-flex'>
            <p className='detail-left'>Address</p>
            <div className='address-wrapper'>
            <p id='detail-address1'>{museum.address1}</p>
            <p id='detail-address2'>{museum.address2}</p>
            </div>
            </div>
            <div className='detail-flex'>
            <p className='detail-left'>Opening Hours</p>
            <p className='detail-right'>{museum.opening_hours}</p>
            </div>
            <div className='detail-flex'>
            <p className='detail-left'>Closing Days</p>
            <p className='detail-right'>{museum.closing_days}</p>
            </div>
            <div className='detail-flex'>
            <p className='detail-left'>Tickets</p>
            <p className='detail-right'>{museum.tickets}</p>
            </div>
            <div className='detail-flex'>
            <p className='detail-left'>Web-Site</p>
            <p className='detail-right'><a href={museum.website}>{museum.name}</a></p>
            </div>
            {/* <Link to={`/museums/list/all/detail/map/${id}`}>Map</Link> */}

            <Switch>
                <Route path={`/museums/list/all/detail/map/:id`}><MapInMuseumDetail/></Route>
                <Route path={`/museums/list/photograph/detail/map/:id`}><MapInMuseumDetail/></Route>
                <Route path={`/museums/list/applied_fine_arts/detail/map/:id`}><MapInMuseumDetail/></Route>
                <Route path={`/museums/list/ancient_art/detail/map/:id`}><MapInMuseumDetail/></Route>
                <Route path={`/museums/list/classic_art/detail/map/:id`}><MapInMuseumDetail/></Route>
                <Route path={`/museums/list/modern_art/detail/map/:id`}><MapInMuseumDetail/></Route>
                <Route path={`/museums/list/contemporary_art/detail/map/:id`}><MapInMuseumDetail/></Route>
                <Route path={`/museums/list/isRecommendation/detail/map/:id`}><MapInMuseumDetail/></Route>
                <Route path={`/museums/list/isFreeAdmission/detail/map/:id`}><MapInMuseumDetail/></Route>
                <Route path={`/museums/list/isOpenMonday/detail/map/:id`}><MapInMuseumDetail/></Route>
                <Route path={`/museums/list/open_museum/detail/map/:id`}><MapInMuseumDetail/></Route>
                <Route path={`/museums/list/close_museum/detail/map/:id`}><MapInMuseumDetail/></Route>

                <Route path={`/museums/list/all/detail/upcoming/:id`}><ExhibitionInMuseumUpcomingDetail/></Route>
                <Route path={`/museums/list/photograph/detail/upcoming/:id`}><ExhibitionInMuseumUpcomingDetail/></Route>
                <Route path={`/museums/list/applied_fine_arts/detail/upcoming/:id`}><ExhibitionInMuseumUpcomingDetail/></Route>
                <Route path={`/museums/list/ancient_art/detail/upcoming/:id`}><ExhibitionInMuseumUpcomingDetail/></Route>
                <Route path={`/museums/list/classic_art/detail/upcoming/:id`}><ExhibitionInMuseumUpcomingDetail/></Route>
                <Route path={`/museums/list/modern_art/detail/upcoming/:id`}><ExhibitionInMuseumUpcomingDetail/></Route>
                <Route path={`/museums/list/contemporary_art/detail/upcoming/:id`}><ExhibitionInMuseumUpcomingDetail/></Route>
                <Route path={`/museums/list/isRecommendation/detail/upcoming/:id`}><ExhibitionInMuseumUpcomingDetail/></Route>
                <Route path={`/museums/list/isFreeAdmission/detail/upcoming/:id`}><ExhibitionInMuseumUpcomingDetail/></Route>
                <Route path={`/museums/list/isOpenMonday/detail/upcoming/:id`}><ExhibitionInMuseumUpcomingDetail/></Route>
                <Route path={`/museums/list/open_museum/detail/upcoming/:id`}><ExhibitionInMuseumUpcomingDetail/></Route>
                <Route path={`/museums/list/close_museum/detail/upcoming/:id`}><ExhibitionInMuseumUpcomingDetail/></Route>

                <Route><ExhibitonInMuseumDetail/></Route>
            </Switch>
            </div>:''}
        </div>
    )
};

export default MuseumDetail;